<template>
  <div v-if="!isPhone" class="md-layout" style="padding: 0px;">
    <div class="md-layout-item md-size-40" />
    <div class="md-layout-item md-size-60" style="padding: 0px;">
      <div style="margin-bottom: 0px; border-bottom: solid .1rem #8e8e8e; ">
        <!--border-top: solid 1px #3c3c3c;-->

        <div>
          <span align="left" style="font-weight:700;font-size: 1.6rem">Search&nbsp;</span>
          <span style="font-weight:100;font-size: 1.6rem">Doctors</span>
          <span style="float: right;">{{ recordsFound }} Records Found</span>
        </div>
      </div>
    </div>

    <div class="md-layout-item md-size-40" />
    <div class="md-layout-item md-size-60" style="padding: 0px;">
      <div class="md-layout md-gutter" style="padding: 0px;">
        <div class="md-layout-item  md-size-70">
          <ul style="padding: 0px; margin-top:15px;">
            <li v-for="(dr, index) in paginatedData">
              <!--doctors.slice(0, 10)-->
              <div
                style="height: 130px; padding: 10px 0px 10px 20px; line-height: 16px;  border-bottom:solid 1px #3c3c3c;"
              >
                <!--border-left:solid 1px #3c3c3c;-->
                <div>
                  <!--
                      <img
                        v-if="dr.ProfileImage"
                        :src="ProfileImageFile(dr.ProfileImage)"
                        class="drimg"
                        alt=""
                        style="margin: 10px 10px; "
                        @click="showModal(dr.id)">
                      <img
                        v-else
                        class="drimg"
                        src="/img/no-img.png"
                        alt=""
                        style="margin: 10px 10px; "
                        @click="showModal(dr.id)">-->
                </div>
                <div>
                  <p style="font-size: 1.2rem; font-weight:400; margin: 0px; ">{{ dr.FirstName }} {{ dr.LastName }}</p>
                  <p v-if="dr.Qualification.indexOf('MD') > -1" style="font-size: .83rem; margin: 0px 0px 7px 0px">
                    <i>Ophthalmologist</i>
                  </p>
                  <p v-else-if="dr.Qualification.indexOf('OD') > -1" style="font-size: .83rem; margin: 0px 0px 7px 0px">
                    <i>Optometrist</i>
                  </p>
                  <p v-else-if="dr.Qualification.indexOf('DO') > -1" style="font-size: .83rem; margin: 0px 0px 7px 0px">
                    <i>Osteopathy</i>
                  </p>
                  <p v-else style="font-size: .83rem; margin: 0px 0px 7px 0px;">
                    <i>{{ dr.Qualification }}</i>
                  </p>

                  <p v-if="dr.Practice" style="font-size: .95rem; margin: 0px;">
                    {{ dr.Practice }}
                  </p>
                  <p v-if="dr.City" style="font-size: .87rem; margin: 0px 0px 7px 0px;">
                    {{ dr.City }}, {{ dr.State }} &nbsp;&nbsp; {{ dr.Country }}
                  </p>
                  <!--<span v-if="dr.Website"><br>{{ dr.Website }}</span>-->
                </div>

                <p v-if="dr.CellNumber" style="font-size: .90rem; margin: 0px; ">
                  <b>Contact:&nbsp;</b>{{ dr.CellNumber }}
                </p>
                <p v-if="dr.Email" style="font-size: .90rem; margin: 0px; "><b>Email:&nbsp;</b>{{ dr.Email }}</p>
              </div>
            </li>
          </ul>

          <div class="md-layout md-layout-nowrap">
            <md-button class="md-layout-item md-default md-sm" @click="prevPage">Previous</md-button>

            <md-button class="md-layout-item  md-default md-sm" style="margin-left: 10px;" @click="nextPage">
              Next</md-button
            >
          </div>
        </div>

        <div align="right" class="md-layout-item md-size-30" style="padding: 0px; margin: 0px;">
          <select
            id="select"
            v-model="search.qualification"
            required
            class="form-control"
            style="margin-top: 15px; width:200px;"
            @change="chgQual"
          >
            <option value="" disabled selected>- Select Specialization -</option>
            <!--<option value="PCP">Primary Care Physician</option>-->
            <option value="MD">Ophthalmologist</option>
            <option value="OD">Optometrist</option>
            <option value="DO">Osteopathy</option>
            <option value="SP">Specialist</option>
            <option value="NE">Non-Eye Care</option>
          </select>
          <br />

          <select
            v-model="search.organization"
            class="form-control"
            style="margin-top: 15px; width:200px;"
            @change="chgOrg"
          >
            <option value="all">All Organizations</option>
            <option v-if="currentOrg" :value="currentOrg.id">{{ currentOrg.name }}</option>
          </select>

          <br />

          <input v-model="search.doctor" class="form-control srch" type="text" placeholder="Doctor Name" />
          <br />
          <input v-model="search.address" class="form-control srch" type="text" placeholder="Address" />
          <br />
          <input v-model="search.zip" class="form-control srch" type="text" placeholder="Postal Code" />
          <br />
          <input v-model="search.city" class="form-control srch" type="text" placeholder="City" />
          <br />
          <input v-model="search.other" class="form-control srch" type="text" placeholder="-other-" />
          <br />

          <div class="md-layout md-layout-nowrap">
            <md-button class="md-layout-item md-size-33 md-primary md-sm" @click="Search">
              Search
            </md-button>
            <md-button class="md-layout-item md-size-33 md-danger md-sm" style="margin-left: 5px;" @click="clearSearch">
              Clear
            </md-button>
            <md-button
              class="md-layout-item md-size-33 md-default md-sm"
              style="margin-left:5px;"
              @click.navigate="$router.push('/reading-center')"
            >
              Exit
            </md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="md-layout md-alignment-center-center" style="padding: 0px;">
      <div class="md-layout-item md-size-70" style="padding: 0px;">
        <div style="margin-bottom: 0px; border-bottom: solid .1rem #8e8e8e; ">
          <!--border-top: solid 1px #3c3c3c;-->

          <div>
            <span align="left" style="font-weight:700;font-size: 1.6rem">Search&nbsp;</span>
            <span style="font-weight:100;font-size: 1.6rem">Doctors</span>
            <span style="float: right;">{{ recordsFound }} Records Found</span>
          </div>
        </div>
      </div>
    </div>
    <div class="md-layout">
      <div class="md-layout md-gutter md-alignment-center-center" style="padding: 0px;">
        <div class="md-layout-item  md-size-70">
          <ul style="padding: 0px; margin-top:15px;">
            <li v-for="(dr, index) in paginatedData">
              <!--doctors.slice(0, 10)-->
              <div
                style="height: 130px; padding: 10px 0px 10px 20px; line-height: 16px;  border-bottom:solid 1px #3c3c3c;"
              >
                <!--border-left:solid 1px #3c3c3c;-->
                <div />
                <div>
                  <p style="font-size: 1.2rem; font-weight:400; margin: 0px; ">{{ dr.FirstName }} {{ dr.LastName }}</p>
                  <p v-if="dr.Qualification.indexOf('MD') > -1" style="font-size: .83rem; margin: 0px 0px 7px 0px">
                    <i>Ophthalmologist</i>
                  </p>
                  <p v-else-if="dr.Qualification.indexOf('OD') > -1" style="font-size: .83rem; margin: 0px 0px 7px 0px">
                    <i>Optometrist</i>
                  </p>
                  <p v-else-if="dr.Qualification.indexOf('DO') > -1" style="font-size: .83rem; margin: 0px 0px 7px 0px">
                    <i>Osteopathy</i>
                  </p>
                  <p v-else style="font-size: .83rem; margin: 0px 0px 7px 0px;">
                    <i>{{ dr.Qualification }}</i>
                  </p>

                  <p v-if="dr.Practice" style="font-size: .95rem; margin: 0px;">
                    {{ dr.Practice }}
                  </p>
                  <p v-if="dr.City" style="font-size: .87rem; margin: 0px 0px 7px 0px;">
                    {{ dr.City }}, {{ dr.State }} &nbsp;&nbsp; {{ dr.Country }}
                  </p>
                  <!--<span v-if="dr.Website"><br>{{ dr.Website }}</span>-->
                </div>

                <p v-if="dr.CellNumber" style="font-size: .90rem; margin: 0px; ">
                  <b>Contact:&nbsp;</b>{{ dr.CellNumber }}
                </p>
                <p v-if="dr.Email" style="font-size: .90rem; margin: 0px; "><b>Email:&nbsp;</b>{{ dr.Email }}</p>
              </div>
            </li>
          </ul>

          <div class="md-layout md-layout-nowrap">
            <md-button class="md-layout-item md-default md-sm" @click="prevPage">Previous</md-button>

            <md-button class="md-layout-item  md-default md-sm" style="margin-left: 10px;" @click="nextPage">
              Next</md-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="md-layout md-alignment-center-center">
      <div align="right" class="md-layout-item md-size-60" style="padding: 0px; margin: 0px;">
        <select
          id="select"
          v-model="search.qualification"
          required
          class="form-control"
          style="margin-top: 15px; width:200px;"
          @change="chgQual"
        >
          <option value="" disabled selected>- Select Specialization -</option>
          <!--<option value="PCP">Primary Care Physician</option>-->
          <option value="MD">Ophthalmologist</option>
          <option value="OD">Optometrist</option>
          <option value="DO">Osteopathy</option>
          <option value="SP">Specialist</option>
          <option value="NE">Non-Eye Care</option>
        </select>

        <br />

        <input v-model="search.doctor" class="form-control srch" type="text" placeholder="Doctor Name" />
        <br />
        <input v-model="search.address" class="form-control srch" type="text" placeholder="Address" />
        <br />
        <input v-model="search.zip" class="form-control srch" type="text" placeholder="Postal Code" />
        <br />
        <input v-model="search.city" class="form-control srch" type="text" placeholder="City" />
        <br />
        <input v-model="search.other" class="form-control srch" type="text" placeholder="-other-" />
        <br />
        <select
          v-model="search.organization"
          class="form-control"
          style="margin-top: 15px; width:200px;"
          @change="chgOrg"
        >
          <option value="all">All Organizations</option>
          <option v-if="currentOrg" :value="currentOrg.id">{{ currentOrg.name }}</option>
        </select>
        <br />

        <div class="md-layout md-layout-nowrap">
          <md-button class="md-layout-item md-size-33 md-primary md-sm" @click="Search">
            Search
          </md-button>
          <md-button class="md-layout-item md-size-33 md-danger md-sm" style="margin-left: 5px;" @click="clearSearch">
            Clear
          </md-button>
          <md-button
            class="md-layout-item md-size-33 md-default md-sm"
            style="margin-left:5px;"
            @click.navigate="$router.push('/reading-center')"
          >
            Exit
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import ... from '@/components/...'
export default {
  name: "NewComponent",
  components: {},
  data() {
    return {
      clearQual: true,
      search: {
        qualification: "",
        organization: "all",
        specialization: null,
        doctor: null,
        address: null,
        zip: null,
        city: null,
        other: null
      },
      currentOrg: null,
      payload: [],
      doctors: [],
      doctor: {},
      pageNumber: 0
    }
  },
  computed: {
    pageSize() {
      if (this.isPhone) {
        return 2
      } else {
        return 4
      }
    },
    recordsFound: function() {
      return this.doctors.length
    },
    pageCount() {
      let l = this.doctors.length,
        s = this.pageSize
      return Math.ceil(l / s)
    },
    paginatedData() {
      let start = this.pageNumber * this.pageSize
      let end = start + this.pageSize

      return this.doctors.slice(start, end)
    },
    isPhone() {
      if (window.screen.width < 760) {
        return true
      } else {
        return false
      }
    }
  },
  created: function() {
    this.loadCurrentOrg();
    this.getDoctors();
  },
  mounted: function() {},
  updated: function() {},
  destroyed: function() {},
  methods: {
    ProfileImageFile: function(fi) {
      const profileFolder = "../assets/img/profiles/"
      console.log(fi)
      return profileFolder + fi
    },
    async getDoctors() {
      try {
        let orgid;
        if (this.search.organization !== "all") {
          orgid = this.search.organization;
        }
      
        const url = `${process.env.VUE_APP_URL}/dractive/null/null`;
        const response = await window.axios.get(url, { params: { orgid }  });

        this.payload = response.data.items;
        this.initializeDoctors();
        this.filterDoctors();
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    },
    async getDoctorDetail() {
      var vm = this
      var url = process.env.VUE_APP_URL + "/drregistration/" + uri

      console.log("getDoctorDetail:GET " + url)
      await window.axios
        .get(url)
        .then(function(response) {
          vm.doctor = response.data[0]
          //console.log(response.data[0])
        })
        .catch(function(error) {
          vm.status = "An error occurred: " + error
          //console.log(vm.status + '\n' + API_SERVICE)
        })
    },
    nextPage() {
      this.pageNumber++
    },
    prevPage() {
      this.pageNumber--
      if (this.pageNumber < 0) {
        this.pageNumber = 0
      }
    },
    initializeDoctors() {
      this.doctors = this.payload
    },
    loadCurrentOrg() {
      const org = localStorage.getItem('currentOrg');
      if (org) {
        try {
          this.currentOrg = JSON.parse(org);
          if (this.currentOrg && this.currentOrg.id) {
            this.search.organization = this.currentOrg.id;
          }
        } catch (e) {
          console.error('Error parsing currentOrg from localStorage', e);
        }
      }
    },
    chgOrg() {
      this.pageNumber = 0;
      this.getDoctors();
    },
    Search() {
      this.initializeDoctors()
      this.filterDoctors()
    },
    clearSearch() {
      this.search.doctor = null
      this.search.address = null
      this.search.zip = null
      this.search.city = null
      this.search.other = null
      if (this.clearQual) {
        this.search.qualification = ""
      }
      this.initializeDoctors()
      this.filterDoctors()
      this.pageNumber = 0
    },
    filterDoctors() {
      if (this.search.qualification != "") {
        this.filterQual()
      }
      if (this.search.doctor) {
        this.doctors = this.doctors.filter(dr => dr.FullName != null)
        this.doctors = this.doctors.filter(
          dr => dr.FullName.toLowerCase().indexOf(this.search.doctor.toLowerCase().trim()) > -1
        )
      }
      if (this.search.address) {
        this.doctors = this.doctors.filter(dr => dr.Address != null)
        this.doctors = this.doctors.filter(
          dr => dr.Address.toLowerCase().indexOf(this.search.address.toLowerCase().trim()) > -1
        )
      }
      if (this.search.zip) {
        this.doctors = this.doctors.filter(dr => dr.Zip != null)
        this.doctors = this.doctors.filter(dr => dr.Zip.startsWith(this.search.zip.trim(), 0))
      }
      if (this.search.city) {
        this.doctors = this.doctors.filter(dr => dr.City != null)
        this.doctors = this.doctors.filter(
          dr => dr.City.toLowerCase().indexOf(this.search.city.toLowerCase().trim()) > -1
        )
      }
      if (this.search.other) {
        this.doctors = this.doctors.filter(dr => dr.SubSpecialization != null)
        this.doctors = this.doctors.filter(
          dr => dr.SubSpecialization.toLowerCase().indexOf(this.search.other.toLowerCase().trim()) > -1
        )
      }

      this.pageNumber = 0
    },
    chgQual() {
      this.clearQual = false
      this.clearSearch()
      this.clearQual = true
      this.pageNumber = 0
    },
    filterQual() {
      if (this.search.qualification == "MD") {
        this.doctors = this.doctors.filter(dr => dr.Qualification != null)
        this.doctors = this.doctors.filter(
          dr => dr.Qualification.indexOf("MD") > -1 || dr.Qualification.indexOf("MBBS") > -1
        )
      } else if (this.search.qualification == "OD") {
        this.doctors = this.doctors.filter(dr => dr.Qualification != null)
        this.doctors = this.doctors.filter(dr => dr.Qualification.indexOf("OD") > -1)
      } else if (this.search.qualification == "DO") {
        this.doctors = this.doctors.filter(dr => dr.Qualification != null)
        this.doctors = this.doctors.filter(dr => dr.Qualification.indexOf("DO") > -1)
      } //else if (this.search.qualification == 'PCP'){
      //this.doctors = this.doctors.filter(dr => dr.Specialization.indexOf('Physician') > -1)}
      else if (this.search.qualification == "SP") {
        this.doctors = this.doctors.filter(dr => dr.SubSpecialization != null)
        this.doctors = this.doctors.filter(dr => dr.SubSpecialization != "")
      } else if (this.search.qualification == "NE") {
        this.doctors = this.doctors.filter(dr => dr.Specialties != null)
        this.doctors = this.doctors.filter(dr => dr.Specialties != "")
      }
    },
    showModal(e) {
      this.doctor = this.doctors.find(x => x.id === e)
      showModalDrDetail()
    }
  }
}
</script>

<style scoped>
body {
  color: #ffffff;
}

select:required:invalid {
  color: gray;
}

option[value=""][disabled] {
  display: none;
}

select:required {
  font-size: 16px;
}

.no-padding {
  padding: 0px;
}

#select {
  color: white;
}

#select option {
  color: white;
  background-color: #000000;
}

ul {
  list-style-type: none;
}

.drimg {
  max-width: 120px;
  max-height: 120px;
  width: auto;
  height: auto;
}

ol,
ul {
  margin-top: 0;
  margin-bottom: 0px;
}

.srch {
  width: 200px;
  font-size: 14px;
  color: rgb(82, 201, 118);
}

select.form-control {
  background-color: #2c2c2c;
  color: white;
  border: 1px solid #444;
}

select.form-control:focus {
  border-color: #666;
  outline: none;
}
</style>
